<template>
  <v-form class="form">
    <div class="inputBox">
      <BaseInput
        :label="$vuetify.breakpoint.mdAndUp ? 'Персональный номер сотрудника в ProApp' : null"
        value="SB0001"
        placeholder="номер в ProApp"
        disabled
      />
    </div>
  </v-form>
</template>

<script>
import BaseInput from 'components/base/BaseInput'
export default {
  name: 'PersonalNumber',
  props: [''],
  components: { BaseInput },
  data: () => ({}),
  methods: {},
}
</script>

<style lang="scss" scoped>
.form {
  padding: 30px;
  background-color: white;
  border: 1px solid #bedbeb;
  border-radius: 4px;
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 0;
    border: none;
  }
}
</style>
